import React, { memo } from "react";

const Item = ({
  id,
  text,
  children = null,
  showDivider = true,
  showBadge = false,
  badgeContent,
  icon,
}) => {
  return (
    <div id={id}>
      {text && (
        <div className="item-wrapper">
          <div className="item me-3">
            {icon && <img src={icon} alt="issue icon" />}
            {text}
          </div>
          {showBadge && badgeContent}
        </div>
      )}
      {children}
      {showDivider && <hr style={{ position: "relative", zIndex: -1000 }} />}
    </div>
  );
};

export default memo(Item);
